// extracted by mini-css-extract-plugin
module.exports = {"container":"zqeXo","button":"Q5uZr","icon":"_21ukB","text":"_18HQ5","title":"_3oA5F","info":"_2b7KO"};